import { render, staticRenderFns } from "./Page-InstagramFeed.vue?vue&type=template&id=5b59a07a&"
import script from "./Page-InstagramFeed.vue?vue&type=script&lang=js&"
export * from "./Page-InstagramFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports